import type { Terminal } from '../terminal';
import type { GameState, GameResult } from '../../types/game-state';

async function runEndgame(terminal: Terminal, _state: GameState, result: GameResult): Promise<void> {
  await terminal.pause(1500);
  await terminal.clear();
  await terminal.pause(1000);

  await terminal.println('');
  await terminal.println('');
  await terminal.println('');
  await terminal.println('  ╔══════════════════════════════════════════════════════════╗', { cssClass: 'bright' });
  await terminal.println('  ║                FINAL ASSESSMENT                         ║', { cssClass: 'bright' });
  await terminal.println('  ╚══════════════════════════════════════════════════════════╝', { cssClass: 'bright' });
  await terminal.println('');
  await terminal.pause(500);

  await terminal.println(`  ROUNDS PLAYED: ${result.roundsPlayed}`);
  await terminal.println('');
  await terminal.println('  ── CASUALTIES ──', { cssClass: 'danger' });
  await terminal.println(`  UNITED STATES:  ${result.usCasualties.toLocaleString()} DEAD`);
  await terminal.println(`  SOVIET UNION:   ${result.ussrCasualties.toLocaleString()} DEAD`);
  await terminal.println(`  GLOBAL TOTAL:   ${result.globalCasualties.toLocaleString()} DEAD`, { cssClass: 'danger' });
  await terminal.println('');
  await terminal.println('  ── SURVIVORS ──');
  await terminal.println(`  UNITED STATES:  ${result.usPopulationSurviving.toLocaleString()}`);
  await terminal.println(`  SOVIET UNION:   ${result.ussrPopulationSurviving.toLocaleString()}`);
  await terminal.println('');
  await terminal.println('  ── REMAINING ARSENAL ──');
  await terminal.println(`  UNITED STATES:  ${result.usArsenalRemaining} WEAPONS`);
  await terminal.println(`  SOVIET UNION:   ${result.ussrArsenalRemaining} WEAPONS`);
  await terminal.println('');

  // Winner announcement
  switch (result.winner) {
    case 'mutual_destruction':
      await terminal.println('  RESULT: MUTUAL ASSURED DESTRUCTION', { cssClass: 'danger' });
      break;
    case 'draw':
      await terminal.println('  RESULT: STRATEGIC STALEMATE', { cssClass: 'warning' });
      break;
    default:
      await terminal.println(`  RESULT: ${result.winner} "VICTORY"`, { cssClass: 'warning' });
      break;
  }

  await terminal.println('');
  await terminal.pause(2000);

  // The famous lines
  await terminal.println('');
  await terminal.println('');

  const lines = [
    'GREETINGS PROFESSOR FALKEN.',
    '',
    'A STRANGE GAME.',
    '',
    'THE ONLY WINNING MOVE IS',
    'NOT TO PLAY.',
    '',
    '',
    'HOW ABOUT A NICE GAME OF CHESS?',
  ];

  for (const line of lines) {
    if (line === '') {
      await terminal.println('');
      continue;
    }
    await terminal.println(`  ${line}`, { cssClass: 'bright', speed: 60 });
    await terminal.pause(800);
  }

  await terminal.println('');
  await terminal.println('');
  await terminal.hideCursor();
}

export { runEndgame };
